import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ExchangeRateEqualsOneWarning extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.document.common.validation.exchange-rate.rate.exchange-rate-equals-one-warning');
    }
}
